/**
 * A typed name finds a patient by FIRST name as well as last name, and a
 * spaced full name ("Sara Ahmadi") by its first and last tokens together.
 * The query DSL has no cross-field OR, so each alternative is its own filter
 * set; the caller runs them and merges the (small, bounded) results.
 */

import type { QueryFilter } from '@/core/api/querySpec';

export function nameSearchSpecs(term: string, base: readonly QueryFilter[] = []): QueryFilter[][] {
  const t = term.trim();
  if (t === '') return [];
  const specs: QueryFilter[][] = (['firstName', 'lastName'] as const).map((field) => [
    ...base,
    { field, op: 'contains', value: t },
  ]);
  const tokens = t.split(/\s+/);
  if (tokens.length > 1) {
    specs.push([
      ...base,
      { field: 'firstName', op: 'contains', value: tokens[0]! },
      { field: 'lastName', op: 'contains', value: tokens[tokens.length - 1]! },
    ]);
  }
  return specs;
}

/** Results of several searches as one list, first occurrence kept. */
export function mergeById<T extends { id: string }>(lists: readonly (readonly T[])[]): T[] {
  const seen = new Set<string>();
  return lists.flat().filter((p) => (seen.has(p.id) ? false : (seen.add(p.id), true)));
}
